<template>
  <div class="login-page">
    <div class="login-card">
      <div class="login-brand">
        <img src="/logo.png" alt="Logo" class="brand-logo">
        <h1>青少年人工智能高水平创新人才培养</h1>
        <p>课程平台管理系统</p>
      </div>
      <div class="login-input">
        <div class="input-item">
          <el-input prefix-icon="el-icon-user" v-model="username" placeholder="请输入用户名"></el-input>
        </div>
        <div class="input-item">
          <el-input prefix-icon="el-icon-lock" placeholder="请输入密码" v-model="password" show-password></el-input>
        </div>
      </div>
      <el-button class="login-btn" type="primary" @click="login()">登录</el-button>
    </div>
  </div>
</template>

<script>
  import {login,getUser} from '../../../api/api'
  import { setLock } from '@/utils/lock'
  export default {
    data() {
      return{
        username: '',
        password: ''
      }
    },
    methods: {
        login() {
            if(!this.username) {
                this.$message({
                    message: '请输入用户名',
                    type: 'warning'
                });
                return;
            }
            if(!this.password) {
                this.$message({
                    message: '请输入密码',
                    type: 'warning'
                });
                return;
            }
            var params = {
                username: this.username,
                password: this.password
            }
            login(params).then(res => {
                if(res.code == 1000) {
                    this.$message({
                        message: '登陆成功',
                        type: 'success'
                    });
                    var that = this
                    var token = res.data.token
                    this.$store.commit('user/setToken', token)
                    this.getUserInfo()
                    setLock(false)
                    setTimeout(function() {
                        that.$router.push("/index")
                    },500)
                } else {
                    this.$message.error(res.message);
                }
            })
        },
        getUserInfo() {
            getUser().then(res => {
                if(res.code == 1000) {
                    this.$store.commit('user/setUser', JSON.stringify(res.data))
                }
            })
        },
    },
    created() {

    },
    mounted() {

    }
 }
</script>

<style   scoped>
  .login-page {
      position: relative;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #eef0f4;
      padding: 24px;
  }
  .login-card {
      width: min(400px, 100%);
      padding: 36px 32px 30px;
      background-color: #ffffff;
      border: 1px solid #e7e9ee;
      border-radius: 16px;
      box-shadow: 0 1px 2px rgba(16,24,40,.04), 0 6px 16px rgba(16,24,40,.06);
      display: flex;
      flex-direction: column;
      align-items: center;
  }
  .login-brand {
      text-align: center;
      margin-bottom: 24px;
  }
  .brand-mark {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 52px;
      height: 52px;
      border-radius: 14px;
      background: #FFFFFF;
      color: #fff;
      font-weight: 800;
      font-size: 19px;
      box-shadow: 0 6px 16px rgba(44, 77, 214, 0.3);
      margin-bottom: 14px;
      overflow: hidden;
  }
  .brand-logo {
      width: 52px;
      height: 52px;
      border-radius: 14px;
      object-fit: cover;
      margin-bottom: 14px;
  }
  .login-brand h1 {
      font-size: 20px;
      font-weight: 800;
      color: #111827;
      margin: 0 0 6px;
      font-family: 'Inter', 'SF Pro Text', -apple-system, 'Segoe UI', 'PingFang SC', 'Microsoft YaHei', sans-serif;
  }
  .login-brand p {
      font-size: 13px;
      color: #9ba3af;
      margin: 0;
      font-family: 'Inter', 'SF Pro Text', -apple-system, 'Segoe UI', 'PingFang SC', 'Microsoft YaHei', sans-serif;
  }
  .login-input {
      width: 100%;
      display: flex;
      flex-direction: column;
      gap: 16px;
  }
  .input-item {
      display: flex;
      flex-direction: column;
      gap: 6px;
  }
  .login-btn {
      margin-top: 20px;
      width: 100%;
      height: 42px;
      border-radius: 8px;
      font-weight: 600;
      font-size: 15px;
      font-family: 'Inter', 'SF Pro Text', -apple-system, 'Segoe UI', 'PingFang SC', 'Microsoft YaHei', sans-serif;
  }
  .login-btn:hover {
      background-color: #1d3db0;
      border-color: #1d3db0;
  }
  .el-input ::v-deep .el-input__inner {
    border-radius: 8px;
    background-color: #f9fafb;
    height: 40px;
    border: 1px solid #d4d7dd;
    font-size: 14px;
    transition: border-color 0.18s ease, box-shadow 0.18s ease;
  }
  .el-input ::v-deep .el-input__inner:focus {
    border-color: #2c4dd6;
    box-shadow: 0 0 0 3px #eef3ff;
  }
</style>
